import React from 'react';

export const Rocket = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0, 0, 20, 20"
      fill="none"
      version="1.1"
    >
      <path
        d="M10.7833 9.21667 L4.8916 15.1083"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M5.52746 10.8325 L2.64163 10.1508 C2.32413 10.0758 2.21246 9.68166 2.44246 9.45083 L4.73746 7.15583 C4.89163 7.00166 5.10079 6.91333 5.31996 6.91166 L7.90746 6.88916"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M16.5658 7.47918 L17.2391 4.23918 C17.4225 3.35752 16.6425 2.57752 15.7608 2.76085 L12.5208 3.43418 C11.5666 3.63252 10.6916 4.10502 10.0033 4.79418 L7.34498 7.45168 C6.33081 8.46585 5.67081 9.78085 5.46248 11.2 L5.45331 11.2608 C5.32164 12.1667 5.62498 13.0808 6.27164 13.7283 C6.91831 14.375 7.83331 14.6783 8.73914 14.5458 L8.79998 14.5367 C10.2191 14.3292 11.5341 13.6683 12.5483 12.6542 L15.2058 9.99668 C15.895 9.30835 16.3675 8.43335 16.5658 7.47918 L16.5658 7.47918 z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M11.1666 3.92834 C13.0925 5.24168 14.7583 6.90751 16.0716 8.83335"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M9.16663 14.4725 L9.84829 17.3584 C9.92329 17.6759 10.3175 17.7875 10.5483 17.5575 L12.8433 15.2625 C12.9975 15.1084 13.0858 14.8992 13.0875 14.68 L13.11 12.0925"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};
